module.exports = __webpack_public_path__ + "img/header_pagina_roma.63a2e312.jpg";